module.exports = __webpack_public_path__ + "media/images/icons/credit_card/amex-f88d46a9115f545fad95adda56af8079.svg";